import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/energetemplate',
    name: 'POST_ENERGETEMPLATE',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
